import * as _ from "lodash";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import UserPreferenceCollection from "./userPreferenceCollection";
import { PreferencesLoaded, PreferenceUpdated } from "./userPreferenceCollection.actions";
import UserPreference from "./userPreference";


export class UserPreferenceCollectionReducer extends ReducerBase<UserPreferenceCollection> {
    constructor() {
        super();
        this.addHandler(PreferencesLoaded.EventName, this.load);
        this.addHandler(PreferenceUpdated.EventName, this.update);
    }

    load(state: UserPreferenceCollection = initialState.userPreferenceCollection, event: PreferencesLoaded): UserPreferenceCollection {


        return _.reduce<UserPreference, UserPreferenceCollection>(
            event.prefences, 
            (coll, m) => { coll[m.key] = m.value; return coll}, 
            {})
    }

    update(state: UserPreferenceCollection = initialState.userPreferenceCollection, event: PreferenceUpdated): UserPreferenceCollection {

        const newState = {...state};
        newState[event.key] = event.value;

        return newState;
    }

    handleDefault(state: UserPreferenceCollection = initialState.userPreferenceCollection) {
        return state;
    }
}